module.exports = __webpack_public_path__ + "img/blogs_layout5.fa3f3177.png";